
import { profilesTypes } from '../constants/profilesConstants';

const initialState = {
    friends: [],
    invited: [],
    pending: [],
    profiles: [],
    profType: "find",
    filter: "",
    isFiltering: false,
    message: "",
    messageType: "",
    messageTime: 0,
    updateFriendlist: Date.now(),
    donate: {target:0, current:0},
    isPremium: false,
};

export const profilesReducer = (state = initialState, action) => {
    switch (action.type) {
        case profilesTypes.LOAD_FRIENDS:
            return {
                ...state,
                friends: action.friends,
                invited: action.invited,
                pending: action.pending,
            };

        case profilesTypes.LOAD_FILTER:
            return {
                ...state,
                profiles: action.profiles,
                profType: action.profType
            };

        case profilesTypes.SET_PROFILE_TYPE:
            return {
                ...state,
                profType: action.profType
            };

        case profilesTypes.SET_FILTER:
            return {
                ...state,
                filter : action.filter,
                isFiltering : action.isFiltering
            };

        case profilesTypes.SET_MESSAGE:
            return {
                ...state,
                message : action.message,
                messageType : action.messageType,
                messageTime : (new Date()).getTime()
            };
            
        case profilesTypes.UPDATE_FRIENDLIST:
            return {
                ...state,
                updateFriendlist: Date.now()
            };

        case profilesTypes.SET_DONATE:
            return {
                ...state,
                donate: {target: action.donate.target ?? 0, current: action.donate.current ?? 0},
                isPremium: action.donate.isPremium ?? false
            };

        case profilesTypes.RESET:
            return {
                ...state,
                ...initialState
            };


        default:
            return state;
    }
};